export default {
	'no-items-to-show': 'No items found in plan for this period.',
	'material-name': 'Material Name',
	'form-type': 'Form Type',
	quantity: 'Quantity',
	classification: 'Classification',
	search: 'Search',
	reset: 'Reset',
	'from-date': 'From',
	'to-date': 'To',
}
